if (!customElements.get('ct-buy')) {
  customElements.define('ct-buy', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-ct-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-ct-thumb]'));
      this.thumbBox = this.querySelector('[data-ct-thumbs]');
      this.index = 0;
      this.thumbs.forEach((t, k) => t.addEventListener('click', () => this.go(k)));
      const prev = this.querySelector('[data-ct-prev]');
      const next = this.querySelector('[data-ct-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
      if (next) next.addEventListener('click', () => this.go(this.index + 1));
      const main = this.querySelector('[data-ct-main]');
      if (main && this.slides.length > 1) {
        let x0 = null;
        main.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', (e) => {
          if (x0 === null) return;
          const dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }
      this.gifts = Array.from(this.querySelectorAll('[data-ct-gift]'));
      this.giftHint = this.querySelector('[data-ct-gift-hint]');
      this.rows = Array.from(this.querySelectorAll('[data-ct-tier]'));
      this.rows.forEach((row, k) => {
        row.addEventListener('click', () => this.pick(row));
        row.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.pick(row); }
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); const r = this.rows[(k + 1) % this.rows.length]; this.pick(r); r.focus(); }
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); const r = this.rows[(k - 1 + this.rows.length) % this.rows.length]; this.pick(r); r.focus(); }
        });
      });
      const start = this.rows.find((r) => r.getAttribute('aria-checked') === 'true') || this.rows[0];
      this.firstPick = true;
      if (start) this.pick(start);
      this.firstPick = false;
      this.form = this.querySelector('[data-ct-form]');
      if (this.form) this.form.addEventListener('submit', (e) => this.add(e));
      this.delivery();
    }
    go(k) {
      if (this.slides.length < 2) return;
      this.index = (k + this.slides.length) % this.slides.length;
      this.slides.forEach((s, i) => {
        s.classList.toggle('is-on', i === this.index);
        if (i !== this.index) s.querySelectorAll('video').forEach((v) => v.pause());
      });
      this.thumbs.forEach((t, i) => t.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
      const t = this.thumbs[this.index];
      if (t && this.thumbBox) this.thumbBox.scrollTo({ left: t.offsetLeft - this.thumbBox.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
    }
    pick(row) {
      this.rows.forEach((r) => { const on = r === row; r.setAttribute('aria-checked', on ? 'true' : 'false'); r.tabIndex = on ? 0 : -1; });
      const id = this.querySelector('[data-ct-id]');
      const qty = this.querySelector('[data-ct-qty]');
      const price = this.querySelector('[data-ct-add-price]');
      if (id) id.value = row.dataset.variant;
      if (qty) qty.value = row.dataset.qty;
      if (price) price.textContent = row.dataset.price;
      this.updateGifts(row.classList.contains('ct-row--feat'));
    }
    updateGifts(feat) {
      if (!this.gifts || !this.gifts.length) return;
      let locked = 0;
      this.gifts.forEach((g) => {
        const needFeat = g.dataset.unlock === 'feat';
        const isLocked = needFeat && !feat;
        const wasLocked = g.classList.contains('is-locked');
        g.classList.toggle('is-locked', isLocked);
        g.setAttribute('aria-label', g.dataset.title + (isLocked ? ' : ' + g.dataset.offText : ' : ' + g.dataset.onText));
        if (isLocked) locked++;
        if (wasLocked && !isLocked && !this.firstPick) {
          g.classList.remove('is-pop'); void g.offsetWidth; g.classList.add('is-pop');
        }
      });
      if (this.giftHint) this.giftHint.hidden = locked === 0;
    }
    delivery() {
      const el = this.querySelector('[data-ct-deliv]');
      if (!el) return;
      const min = parseInt(el.dataset.min, 10);
      const max = parseInt(el.dataset.max, 10);
      if (!min || !max) return;
      const addDays = (n) => { const d = new Date(); let c = 0; while (c < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) c++; } return d; };
      try {
        const f = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short' });
        el.textContent = f.format(addDays(min)) + ' – ' + f.format(addDays(Math.max(min, max)));
      } catch (e) {}
    }
    async add(e) {
      e.preventDefault();
      const btn = this.querySelector('[data-ct-add]');
      const err = this.querySelector('[data-ct-error]');
      if (err) err.hidden = true;
      if (btn) btn.disabled = true;
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const fd = new FormData(this.form);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        fd.append('sections', cart.getSectionsToRender().map((s) => s.id));
        fd.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
      const addUrl = (window.routes && window.routes.cart_add_url) || this.form.getAttribute('action');
      try {
        const res = await fetch(addUrl, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd });
        const data = await res.json();
        if (data.status) {
          if (err) { err.textContent = data.description || data.message || 'Erreur'; err.hidden = false; }
          return;
        }
        if (!cart || typeof cart.renderContents !== 'function') {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ct-buy', productVariantId: fd.get('id'), cartData: data });
        }
        cart.classList.remove('is-empty');
        cart.renderContents(data);
      } catch (error) {
        HTMLFormElement.prototype.submit.call(this.form);
      } finally {
        if (btn) btn.disabled = false;
      }
    }
  });
}